import React from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { Button, CardActions } from '@one-thd/sui-atomic-components';
import { showBelowSmBreakpoint } from '../../constants/responsiveClassNames';
import ListsHeader from './ListsHeader';
import { useContainerWidth } from '../../hooks/useContainerWidth';
import ListCarousel from './ListCarousel';
import ListsCompactList from './ListsCompactList';
import { NAVIGATION_URLS } from '../../constants/navigationUrls';

const { arrayOf, number, shape } = proptypes;

const renderActionButtons = ({ isCompactView }) => {
  if (!isCompactView) {
    return null;
  }
  return (
    <div className={classNames(showBelowSmBreakpoint, 'sui-mt-auto')}>
      <CardActions>
        <Button fullWidth href={NAVIGATION_URLS.VIEW_ALL_LISTS}>View All Lists</Button>
      </CardActions>
    </div>
  );
};

const ListsContainer = ({ lists, maxMobileListSize, iconSize, componentId }) => {
  const [containerRef, width] = useContainerWidth();
  // sm breakpoint
  const isCompactView = width < 376;
  const headerActions = isCompactView ? ['createNew'] : ['createNew', 'viewAll'];

  return (
    <div
      ref={containerRef}
      data-testid="lists-container"
      id="user-lists-v2"
      className="sui-@container sui-h-full"
    >
      <ListsHeader
        actions={headerActions}
        listCount={lists.length}
      />
      {isCompactView ? (
        <div>
          <ListsCompactList
            lists={lists}
            iconSize={iconSize}
            maxMobileListSize={maxMobileListSize}
          />
        </div>
      ) : (
        <ListCarousel
          lists={lists}
          iconSize={iconSize}
          componentId={componentId}
        />
      )}
      {renderActionButtons({ isCompactView })}
    </div>
  );
};

ListsContainer.propTypes = {
  lists: arrayOf(shape({})),
  maxMobileListSize: number,
  iconSize: proptypes.string,
  componentId: proptypes.string
};
ListsContainer.defaultProps = {
  lists: [],
  maxMobileListSize: 4,
  iconSize: 'small',
  componentId: undefined
};

export default ListsContainer;
